<template>
	<v-card>
		<v-toolbar flat dense color="info" dark>
			<v-toolbar-title class="subheading">These items require your attention, {{ loggedInEmployee.firstName }}</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-divider></v-divider>

		<v-card-text>
			<v-list two-line class="flexible-height">
				<v-list-tile v-for="(item, index) in employeeToDoList" :key="index" @click="onItemClicked(item)">
					<v-list-tile-avatar>
						<v-icon :color="getIconMeta(item).color">{{getIconMeta(item).icon}}</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-html="item.title"></v-list-tile-title>
						<v-list-tile-sub-title v-html="item.message"></v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		props: {
			loggedInEmployee: {
				type: Object,
				required: true
			},
			employeeToDoList: {
				type: Array,
				required: true
			}
		},
        methods: {
            getIconMeta(item) {
                switch (item.type) {
                    case 'pd_acknowledgement':
                        return { icon: 'mdi-file-document-edit-outline', color: 'purple' };
					case 'policy_acknowledgement':
                        return { icon: 'mdi-file-document-outline', color: 'error' };
					case 'form_assignment':
						return { icon: 'mdi-form-select', color: 'info' };
					default: 
						return { icon: 'mdi-alert-circle-outline', color: 'info' };
                }
            },
            onItemClicked(item) {
                switch (item.type) {
                    case 'pd_acknowledgement':
                        this.$router.push({ name: 'employeePosition', params: { employeeId: item.refEmployeeId, id: item.refId } });
						break;
					case 'policy_acknowledgement':
                        this.$router.push({ name: 'hrPolicies' });
						break;
					case 'form_assignment':
						this.$router.push({ name: 'myForms' });
						break;
                }
            }
        }
	};
</script>
